<template>
<div id="date-buttons">
    <button type="button" @click="updateElements" data-value="1" id="daily" class="dwm btn btn-secondary" :class="{'reverse':current_dwm != 'daily', 'active':current_dwm == 'daily'}">Daily</button>
    <button type="button" @click="updateElements" data-value="2" id="weekly" class="dwm btn btn-secondary" :class="{'reverse':current_dwm != 'weekly', 'active':current_dwm == 'weekly'}">Weekly</button>
    <button type="button" @click="updateElements" data-value="3" id="monthly" class="dwm btn btn-secondary" :class="{'reverse':current_dwm != 'monthly', 'active':current_dwm == 'monthly'}">Monthly</button>
    <template v-if="is_archive">
        <button type="button" class="btn btn-secondary reverse archive btn-calendar ml-5"
                :date_from="date_from"
                :date_to="date_to"
                :date_compare_from="date_compare_from"
                :date_compare_to="date_compare_to"
                >
            <span class="date-selected"><span>{{$dayjs(date_from).format("MM-DD-YYYY")}} to {{$dayjs(date_to).format("MM-DD-YYYY")}}</span><span class="vs mx-2">VS</span><span>{{$dayjs(date_compare_from).format("MM-DD-YYYY")}} to {{$dayjs(date_compare_to).format("MM-DD-YYYY")}}</span></span>
        </button>
    </template>
    <template v-else>
        <button type="button" id="date-selected" class="btn btn-secondary reverse btn-calendar ml-5"
                :date_from="date_from"
                :date_to="date_to"
                :date_compare_from="date_compare_from"
                :date_compare_to="date_compare_to"
                :calendar="calendar">{{period}}
            <span class="date-selected"><span>{{$dayjs(date_from).format("MM-DD-YYYY")}} to {{$dayjs(date_to).format("MM-DD-YYYY")}}</span><span class="vs mx-2">VS</span><span>{{$dayjs(date_compare_from).format("MM-DD-YYYY")}} to {{$dayjs(date_compare_to).format("MM-DD-YYYY")}}</span></span>
        </button>
        <calendar></calendar>
    </template>
</div>
</template>

<script>
    import calendar from './calendar.vue';
    export default {
        created(){
            event_bus.$on('date_infos', (param) => {
                this.is_archive = this.$store.state.isArchive;
                this.date_from = this.$store.state.current_dates.date_from;
                this.date_to = this.$store.state.current_dates.date_to;
                this.date_compare_from = this.$store.state.current_dates.date_compare_from;
                this.date_compare_to = this.$store.state.current_dates.date_compare_to;
                if(!this.is_archive){
                    this.period = this.$store.state.current_dates.main_period + ' vs ' + this.$store.state.current_dates.compare_period;
                    this.calendar = this.$store.state.current_dates.range;
                }
            });
            event_bus.$on('calendar_saved', (param) => {
                this.is_archive = this.$store.state.isArchive;
                this.date_from = this.$store.state.current_dates.date_from;
                this.date_to = this.$store.state.current_dates.date_to;
                this.date_compare_from = this.$store.state.current_dates.date_compare_from;
                this.date_compare_to = this.$store.state.current_dates.date_compare_to;
                if(!this.is_archive){
                    this.period = this.$store.state.current_dates.main_period + ' vs ' + this.$store.state.current_dates.compare_period;
                    this.calendar = this.$store.state.current_dates.range;
                }

                event_bus.$emit('reloading', true);
            });
            if(this.$store.state.url_params){
                const params = JSON.parse(this.$store.state.url_params);
                this.is_archive = this.$store.state.isArchive;
                this.current_dwm = params.dwm;
                this.date_from = params.dates.date_from;
                this.date_to = params.dates.date_to;
                this.date_compare_from = params.dates.date_compare_from;
                this.date_compare_to = params.dates.date_compare_to;
                if(!this.is_archive){
                    this.period = params.dates.main_period + ' vs ' + params.dates.compare_period;
                }
            }
        },
        data() {
            return {
                is_archive:false,
                current_dwm:'daily',
                period:'last 30 days vs previous 30 days',
                date_from:null,
                date_to:null,
                date_compare_from:null,
                date_compare_to:null,
                calendar:null
            }
        },
        methods: {
            updateElements(){
                var target = $(event.target);
                if (target.hasClass('active') || target.hasClass('pending')) {
                    return false;
                }

                var dwm = target.attr('id');
                this.current_dwm = dwm;
                this.$store.commit('setCurrentDWM',dwm);
                event_bus.$emit('current_dwm', true);
            }
        },
        components: {
            'calendar': calendar
        }
    }
</script>
<style lang="scss">
    @import '~@/_variables.scss';
    div#date-buttons{
        button{
            &.dwm{
                &.active{
                    cursor:default !important;
                }
            }
            &.btn-calendar{
                position:relative;
                width:28rem;
                @media screen and (min-width: 1080px) {
                    width:32rem;
                }
                @media screen and (max-width: 983px) {
                    left:-4.8rem;
                    margin-top:0.5rem;
                }

                span.date-selected{
                    position:absolute;
                    left:0;
                    right:0;
                    bottom:-1.8rem;
                    font-size:0.9rem;
                    color:$secondary !important;
                    @media screen and (min-width: 1080px) {
                        font-size:1rem;
                    }
                }
                &.archive{
                    cursor:default !important;
                    min-height:3.4rem;
                    span.date-selected{
                        bottom:calc(50% - 0.7rem);
                    }
                    &:hover{
                        background-color:white !important;
                    }
                }
            }
        }
    }
</style>
